<template>
  <div></div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SessionExpired',
  async mounted () {
    // Show global loading overlay with session expired message
    this.$store.dispatch('application/setGlobalLoading', {
      show: true,
      message: 'Your previous session has expired, please log in again'
    })

    // Clear session and state
    try {
      this.$store.dispatch('clearRecentException')
      this.$store.dispatch('brochure/setGuestUser', null)
      this.$store.dispatch('user/logout')
      this.$store.dispatch('app/logout')
      await axios.get('/logout', { withCredentials: true }).catch(() => {
        // Ignore errors - session might already be expired
      })
      await this.$store.dispatch('RESET_OVB').catch(() => {
        // Ignore errors
      })
    } catch (e) {
      // Ignore errors - we're logging out anyway
      console.error('Error during session expiry cleanup:', e)
    }

    // Redirect to home page after brief delay
    setTimeout(() => {
      this.$store.dispatch('application/setGlobalLoading', {
        show: false,
        message: ''
      })
      // Use window.location to force full page reload and clear any cached state
      window.location.href = '/?logout=expired'
    }, 1500)
  }
}
</script>

<style scoped>

</style>
